const { ccclass } = cc._decorator;
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../../framework/core/mvvm/module_base";
import CaiChiView from "./caichi_view";
import EventManager from "../../../../manager/event_manager";
import AppData from "../../../public/const/app_data";
import { CountUp } from "../../../../lib/countUp";
import ModuleManager from "../../../../framework/core/module_manager";
import DialogTips from "../../../public/module/dialog_tips/dialog_tips";
import LanguageManager from "../../../../manager/language_manager";
import Util from "../../../longhudou/module/util";
@ccclass
@moduleInit("CaiChi")
export default class CaiChi extends ModuleBase<CaiChiView, null>  {

    lastJackpotData = 0
    constructor() {
        super()
        this.windowPrefabResPath = 'package/yxx/caichi_table'
        this.viewType = CaiChiView;
        this.needViewMask = true
        this.needAnim = true
    }

    onInit() {
        let self = this
        this.eventBind("event_update_caichinum",function(num){
            if(self.lastJackpotData != num){
                let caichiCountUp = new CountUp(null,num,{
                    startVal: self.lastJackpotData,
                    decimalPlaces: 0,
                    duration: 2,
                    useEasing: true,
                    useGrouping: false,
                    smartEasingThreshold: 999,
                    smartEasingAmount: 333,
                    separator: ',',
                    decimal: '.',
                    prefix: '',
                    suffix: ''
                })
                if(!caichiCountUp.error){
                    caichiCountUp.start((n)=>{
                        self.view.caichiNumLab.string = Util.toThousands( n.padStart(10,"0"))
                    })
                }

                self.lastJackpotData = num
            }
           
        })
    }

    onShow(intentData){
        super.onShow(intentData);
        let self = this
        if(intentData.jackpotData != 0){
            let caichiCountUp = new CountUp(null,intentData.jackpotData,{
                startVal: 0,
                decimalPlaces: 0,
                duration: 2,
                useEasing: true,
                useGrouping: false,
                smartEasingThreshold: 999,
                smartEasingAmount: 333,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: ''
            })

            if(!caichiCountUp.error){
                caichiCountUp.start((n)=>{
                    self.view.caichiNumLab.string = Util.toThousands( n.padStart(10,"0"))
                })
            }
            self.lastJackpotData = intentData.jackpotData
        }

        for(let i = 0; i < intentData.caichiData.players.length; i ++){
            intentData.caichiData.players[i].userData = JSON.parse(intentData.caichiData.players[i].userData)
        }
        intentData.caichiData.players.sort(function(a,b){
            return  b.num - a.num
        })

       
        this.view.initShow(intentData.caichiData, intentData.isTb, intentData.isFreeGame)
        this.view.updateShow(intentData.caichiData.players)
    }

    protected onButtonClickName(name : string) {
        switch (name) {
            case "CloseBtn":
                this.hide()
                break;
            case "RuleBtn": 
                ModuleManager.instance.showModule(DialogTips, 
                { Content: "规则规则规则规则规则规则规则规则规则规则规则规则规则规则规则规则规则规则规则规则规则规则规则规则规则规则"/*LanguageManager.t("public_matchTip")*/}
                )
                break;
            default:
                break;
        }
    }




}